export const asterisksToSpan = (text, className = "") => {
  const bold = /\*(.*?)\*/gm
  const html = text.replace(bold, `<span class="${className}">$1</span>`)
  return html
}
